import React from 'react';
import Button from '@mui/material/Button';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../store/useLanguageStore';

const DarkModeBtn = ({ styleClass }: { styleClass?: string }) => {
    const { language } = useLanguageStore();
    const { darkMode, setDarkMode } = useDarkModeStore();

    const handleDarkModeClick = () => {
        setDarkMode(!darkMode);
    };

    return <React.Fragment>
        <Button
            className="button-hover-circle"
            variant="text"
            onClick={handleDarkModeClick}
            title={language['ChangeBackgroundColor']}
        >
            {
                darkMode
                    ? <LightModeOutlinedIcon
                        className={`icon-sidebar-top-color ${styleClass}`}
                        sx={{ width: '22px', height: '22px', color: darkMode ? 'white' : '#4D5F71' }}
                    />
                    : <DarkModeOutlinedIcon
                        className={`icon-sidebar-top-color ${styleClass}`}
                        sx={{ width: '22px', height: '22px', color: darkMode ? 'white' : '#4D5F71' }}
                    />
            }
        </Button>
    </React.Fragment>
}

export default DarkModeBtn;